import ReactModal from "react-modal";
import "../../components/modal/ModalCss.scss";
import BasicInput from "components/input/BasicInput";
import { useEffect, useMemo, useState } from "react";
import { checkAndRemoveInvalid, checkRequiredAndInvalid, makeRequireColumns } from "js/requireCheck";
import BasicButton from "components/button/BasicButton";
import { sendGet, sendPut } from "api/restUtil";
import BasicCheckbox from "components/input/BasicCheckbox";

/**
 * 사용자 추가/수정 팝업
 */
export default function UserAddModModal (props) {

	const { isOpen, onClose, initData, returnData, modalId, title } = props;
	const [ data, setData ] = useState({})
	const [ isIdDupCheck, setIsIdDupCheck ] = useState(false);
	const [ mode, setMode ] = useState("add");


	const idDuplicateCheck = async (loginId) => {
		if(loginId == null || loginId == undefined || loginId === "") {
			alert("로그인 ID를 입력 해 주세요.");
			return;
		}
		const result = await sendGet("/api/mgmt/user/avail-login-id", {loginId: loginId});
		if(result.respCode == "SUCCESS") {
			if(result.data == "Y") {
				alert("사용 가능한 ID 입니다.");
				setIsIdDupCheck(true);
			} else {
				alert("사용중인 ID 입니다.\n다른 ID를 사용해 주세요.");
				setIsIdDupCheck(false);
			}
		} else {
			setIsIdDupCheck(false);
		}
	}

	const onClickOk = () => {
		const requiredColumns = ["loginId", "userNm", ];

		// 필수 체크
		if(!checkRequiredAndInvalid(makeRequireColumns(requiredColumns), data, "#userAddModModal")) return;


		if(mode === "add" && !isIdDupCheck) {
			alert("ID 중복 체크를 해주세요.");
			return;
		}

		returnData(data);
	}
	
	// 데이터 변경 시 invalid 제거 처리
	useEffect(() => {
		checkAndRemoveInvalid(data, "#userAddModModal");
	}, [data]);

	const handleDataChange = (e) => {
		const {name, value} = e.target;
		let d = {...data};

		let val = value;
		// boolean은 text가 아닌 형태로 형변환
		if(value === "true") val = true;
		else if(value === "false") val = false;

		if(e.target.tagName.toLowerCase() === "input" && e.target.type.toLowerCase() === "checkbox") {
			// 체크박스는 선택 여부에 따라서 다르게 처리됨.
			val = Array.from(document.querySelectorAll("#userAddModModal input[type='checkbox'][name=" + e.target.name + "]:checked")).map(obj => obj.value);
			if(name === "headOfficeYn") {
				// obj 구조에 맞추기. (Array아니고, 그냥 1개임)
				val = val[0];
			}
		}

		if(name.includes(".")) {
			let nmArr = name.split(".");
			let obj = d;
			for(let i=0; i<nmArr.length; i++) {
				const key = nmArr[i];

				if(i == nmArr.length - 1) {
					obj[key] = val;
				} else {
					if(!obj.hasOwnProperty(key)) {
						obj[key] = {};
					}
					obj = obj[key];
				}
			}

		} else {
			d[name] = val;
		}

		setData(d);
	}


	useEffect(() => {
		setIsIdDupCheck(false);
	}, [data.loginId]);

	useEffect(() => {

		if(initData.hasOwnProperty("userSeq") && initData.userSeq != null && initData.userSeq !== '') {
			setMode("mod");
			getData(initData);
		} else {
			setMode("add");
			setData({});
		}
	}, [initData]);

	const getData = async (data) => {
		const result = await sendGet("/api/mgmt/user/" + data.userSeq);
		if(result.respCode === "SUCCESS") {
			setData(result.data);
		}
	}

	// 비밀번호 초기화
	const initPw = async () => {
		if(mode !== "mod" || !initData.userSeq) return;
		if(!window.confirm("비밀번호를 초기화 하시겠습니까?")) return;

		const result = await sendPut("/api/mgmt/user/" + initData.userSeq + "/init-pw");
		if(result.respCode === "SUCCESS") {
			alert("비밀번호가 초기화 되었습니다.");
		}
	}


	return (
		<ReactModal
			appElement={document.getElementById("root")}
			isOpen={isOpen}
			// onRequestClose={onClose}
			contentLabel={title + "팝업"}
			id={modalId}
		>
			<div className="me-modal">
				<div className="me-modal-container" style={{width: "600px", height: "500px"}}>
					<div className="me-modal-inner">
						<div className="me-modal-header handle-area">
							<h4 className="header-title">{title}</h4>
						</div>

						<div className="me-modal-body" style={{overflowY: "scroll"}} >	{/* 달력때문에 overflow visible설정 */}
							<div className="body-area modal-form" id="userAddModModal">
								<table className="table-styled">
									<colgroup>
										<col width="150"/>
										<col width="*"/>
									</colgroup>
									<tbody>
										<tr>
											<th>로그인 ID <span className="burgundy">*</span></th>
											<td>
												{mode === "add" && (
													<>
														<BasicInput item={{col: "loginId"}} value={data?.loginId} onChange={handleDataChange} width="250px" textAlign="left" />
														<BasicButton label="중복확인" onClick={()=>idDuplicateCheck(data?.loginId)} className="small-button" style={{marginLeft: "10px"}} />
													</>
												)}
												{mode === "mod" && (
													<>
														<BasicInput item={{col: "loginId"}} value={data?.loginId} readOnly={true} onChange={handleDataChange} width="250px" textAlign="left" />
													</>
												)}
											</td>
										</tr>
										<tr>
											<th>비밀번호</th>
											<td>
												초기 비밀번호는 1234입니다. 
												{mode === "mod" && (
													<BasicButton label="초기화" onClick={()=>initPw()} className="small-button" style={{marginLeft: "10px"}} />
												)}
												
											</td>
										</tr>
										<tr>
											<th>사용자 이름 <span className="burgundy">*</span></th>
											<td>
												<BasicInput item={{col: "userNm"}} value={data?.userNm} onChange={handleDataChange} width="250px" textAlign="left" />
											</td>
										</tr>
										<tr>
											<th>본사 직원 여부</th>
											<td>
												<BasicCheckbox item={{col: "headOfficeYn", checkValue: "Y"}} value={data?.headOfficeYn} onChange={handleDataChange} />
											</td>
										</tr>
										<tr>
											<th>지점 ID</th>
											<td>
												<BasicInput item={{col: "branchId"}} value={data?.branchId} onChange={handleDataChange} width="250px" textAlign="left" />
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>

						<div className="me-modal-footer mg-t-10 mg-b-20">
							<div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton label="취소" className="btn-cancel" onClick={onClose} style={{width: "100%"}} />
								<BasicButton label="확인" className="btn-save" onClick={onClickOk} style={{width: "100%"}} />

							</div>
						</div>

					</div>

				</div>
			</div>

		</ReactModal>
	);
}
